import { useCallback } from "react";
import { useNavigate } from "react-router-dom-v5-compat";
import { TRIPS_PATH } from "@b2bportal/core-utilities";
import type { HotelItinerarySummary } from "@b2bportal/lodging-api";
import { Product } from "@b2bportal/purchase-api";
import { useSessionContext } from "@/components/AuthModule/SessionContext";
import { isCommerceTripsEnabled } from "@/utils/commerce/trips";
import type { GroundBookingContext } from "@/utils/commerce/types";
import {
  buildCarTripDetailsUrl,
  buildStayTripDetailsUrl,
} from "@/utils/commerce/urls";

export const hotelItineraryRoute = (reservationId: string) =>
  `${reservationId}`;

export const useUpcomingTripNavigation = () => {
  const navigate = useNavigate();
  const { sessionInfo } = useSessionContext();

  return useCallback(
    (
      reservationId: string,
      productType?: Product,
      reservation?: HotelItinerarySummary | GroundBookingContext
    ) => {
      if (productType === Product.Ground && reservation) {
        // Cars navigate via tripId using buildCarTripDetailsUrl
        const carReservation = reservation as GroundBookingContext;
        if (carReservation.tripId) {
          window.location.href = buildCarTripDetailsUrl({
            reservationId: carReservation.tripId,
            perkspotUserId: sessionInfo?.userDetails.tenantUserId,
            communityId: sessionInfo?.userDetails.communityId,
          });
        } else {
          console.warn("Car reservation missing tripId:", carReservation);
        }
      } else if (isCommerceTripsEnabled()) {
        // reservationId is the hotel's reservationBookingId, which commerce
        // uses to key stay trip details (ATL-1503).
        window.location.href = buildStayTripDetailsUrl({
          reservationId,
          perkspotUserId: sessionInfo?.userDetails.tenantUserId,
          communityId: sessionInfo?.userDetails.communityId,
        });
      } else {
        // Hotels navigate via reservationId
        navigate(`${TRIPS_PATH}/${hotelItineraryRoute(reservationId)}`);
      }
    },
    [navigate, sessionInfo]
  );
};
